import React, { useState } from 'react';

const correctOrder = ['Hammer', 'Wrench', 'Screwdriver'];
const initialOrder = ['Screwdriver', 'Hammer', 'Wrench'];

function LogicPuzzle({ onComplete }) {
  const [order, setOrder] = useState(initialOrder);
  const [dragged, setDragged] = useState(null);
  const [solved, setSolved] = useState(false);

  const handleDragStart = idx => setDragged(idx);
  const handleDrop = idx => {
    if (dragged === null) return;
    const newOrder = [...order];
    const [removed] = newOrder.splice(dragged, 1);
    newOrder.splice(idx, 0, removed);
    setOrder(newOrder);
    setDragged(null);
  };
  const handleDragOver = e => e.preventDefault();

  const checkSolution = () => {
    if (order.join() === correctOrder.join()) {
      setSolved(true);
      setTimeout(onComplete, 1000);
    }
  };

  return (
    <div style={{ padding: 16, textAlign: 'center' }}>
      <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 12 }}>Arrange the Tools</h3>
      <div style={{ color: '#555', marginBottom: 18 }}>Drag and drop to arrange the tools in the correct order for a basic repair: Hammer, Wrench, Screwdriver.</div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginBottom: 18 }}>
        {order.map((tool, idx) => (
          <div
            key={tool}
            draggable
            onDragStart={() => handleDragStart(idx)}
            onDrop={() => handleDrop(idx)}
            onDragOver={handleDragOver}
            style={{
              background: '#f8fafc',
              border: '2px solid #e5e7eb',
              borderRadius: 10,
              padding: '18px 22px',
              fontWeight: 600,
              fontSize: 18,
              cursor: 'grab',
              opacity: dragged === idx ? 0.5 : 1,
              boxShadow: '0 2px 8px rgba(34,197,94,0.07)',
              transition: 'opacity 0.2s',
            }}
          >
            {tool}
          </div>
        ))}
      </div>
      <button className="gogig-card-btn" style={{ width: 180 }} onClick={checkSolution} disabled={solved}>{solved ? 'Solved!' : 'Check'}</button>
      {solved && <div style={{ color: '#22c55e', fontWeight: 700, marginTop: 12 }}>Great job!</div>}
    </div>
  );
}

export default LogicPuzzle; 